const ENV='PRO';
const getBaseUrl = ()=>{
    if(ENV=='DEV')
        return 'http://localhost:5000/dev/api/v2';
    return 'https://9w8k145cwa.execute-api.eu-west-3.amazonaws.com/dev/dev/api/v2';
}

export default getBaseUrl;